import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const n = o("n-popover-body");
export {
  n as popoverBodyInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popover/src/interface.js
// module id = 257
// module chunks = 41